import { useMemo } from 'react';

type Params<T> = {
  /** Прочитанная выдача справочника */
  items: T[];
  /** Ключ записи */
  getItemId: (item: T) => string | number;
  /**
   * Ключи записей состава: окно их не предлагает. Окно, открытое с текущим составом отмеченным,
   * их не передаёт — там состав отмечен, а не исключён
   */
  excludedIds?: ReadonlyArray<string | number>;
  /**
   * Набранный запрос. Окно с поиском на сервере его не передаёт: выдачу под запрос уже собрал
   * сервер, и на месте из неё вычитается только состав
   */
  search?: string;
  /**
   * Запись подходит под запрос; запрос приходит без пробелов по краям и в нижнем регистре.
   * Без него запрос выдачу не сужает
   */
  matchesSearch?: (item: T, query: string) => boolean;
};

/**
 * Выдача окна выбора, которое отбирает записи справочника на месте: без записей состава и под
 * набранный запрос.
 */
export const useLocalSelectionItems = <T>({ items, getItemId, excludedIds, search, matchesSearch }: Params<T>): T[] =>
  useMemo(() => {
    const excluded = new Set(excludedIds);
    const query = search?.trim().toLowerCase();
    return items.filter(
      (item) => !excluded.has(getItemId(item)) && (!query || !matchesSearch || matchesSearch(item, query)),
    );
  }, [items, getItemId, excludedIds, search, matchesSearch]);
